/**
 * The renderer's words for a list drawn as a timeline (docs/design/calendar-and-timeline.md, list
 * standard §13). Kept beside the catalogue and spread into it, so a parallel change to the catalogue
 * does not collide with these.
 */
export const TIMELINE_EN = {
    'timeline.show': 'Timeline',
    'timeline.label': 'Timeline',
    'timeline.scale.label': 'Scale',
    'timeline.scale.day': 'Days',
    'timeline.scale.week': 'Weeks',
    'timeline.scale.month': 'Months',
    'timeline.today': 'Today',
    'timeline.weekend': 'Weekend',
    'timeline.group.none': 'No group',
    'timeline.empty': 'Nothing here has a start date to place on the timeline.',
    'timeline.undated': '{n} rows have no start date, so they are not on the timeline; the table shows them.',
    'timeline.scope.page': 'This page holds rows {from} to {to} of {total}; the timeline draws this page.',
    'timeline.narrow': 'The timeline needs a wider screen, so the table is shown.',
    'timeline.bar.span': '{from} – {to}',
    'timeline.bar.milestone': 'Milestone · {day}',
    'timeline.bar.progress': '{n}% done',
};
export const TIMELINE_AR = {
    'timeline.show': 'مخطط زمني',
    'timeline.label': 'المخطط الزمني',
    'timeline.scale.label': 'المقياس',
    'timeline.scale.day': 'أيام',
    'timeline.scale.week': 'أسابيع',
    'timeline.scale.month': 'أشهر',
    'timeline.today': 'اليوم',
    'timeline.weekend': 'عطلة نهاية الأسبوع',
    'timeline.group.none': 'بلا مجموعة',
    'timeline.empty': 'لا شيء هنا له تاريخ بداية يوضع به على المخطط الزمني.',
    'timeline.undated': '{n} صفوف بلا تاريخ بداية، فلا تظهر على المخطط الزمني؛ يعرضها الجدول.',
    'timeline.scope.page': 'في هذه الصفحة الصفوف من {from} إلى {to} من أصل {total}؛ يرسم المخطط الزمني هذه الصفحة.',
    'timeline.narrow': 'يحتاج المخطط الزمني شاشة أعرض، فيُعرض الجدول.',
    'timeline.bar.span': '{from} – {to}',
    'timeline.bar.milestone': 'معلم · {day}',
    'timeline.bar.progress': 'أُنجز {n}%',
};
//# sourceMappingURL=i18n-timeline.js.map